import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Cache, CacheContext } from './context';

export const useCache = (): CacheContext => {
  const cache = useContext(Cache);
  const history = useHistory();

  return {
    ...cache,
    nextStepAnimationSkip: history.action === "POP"
  }
};
